module.exports = __webpack_public_path__ + "static/media/on.98fa4afb.svg";